export default function CTASection() {
  return (
    <section className="bg-background-50 py-20 md:py-24">
      <div className="w-full px-4 md:px-6 lg:px-12 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-tight">
          Get Access to the Most Updated PandaBuySpreadsheet Collections
        </h2>
        <p className="mt-4 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
          Join thousands of smart shoppers who rely on our curated pandabuyspreadsheet hub for the best finds, updated daily.
        </p>
        <div className="mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-colors duration-300 whitespace-nowrap cursor-pointer"
          >
            Access Spreadsheet Hub Now
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-8 mt-12 pt-10 border-t border-background-200/60">
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">10,000+</p>
            <p className="text-xs text-foreground-400 mt-1">Weekly Active Users</p>
          </div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">14</p>
            <p className="text-xs text-foreground-400 mt-1">Curated Categories</p>
          </div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">24h</p>
            <p className="text-xs text-foreground-400 mt-1">Update Frequency</p>
          </div>
        </div>
      </div>
    </section>
  );
}